import type { SearchResults } from '@core/entities/SearchResult';
import type { SearchRepository } from '@core/repositories/SearchRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface SearchResponse {
  data: {
    collections: Array<{ id: string; name: string; description: string | null }>;
    folders: Array<{ id: string; name: string; collection_id: string }>;
    requests: Array<{
      id: string;
      name: string;
      method: string;
      collection_id: string;
      folder_id: string | null;
    }>;
  };
}

export class SearchRepositoryImpl implements SearchRepository {
  async search(workspaceId: string, query: string): Promise<SearchResults> {
    try {
      const response = await httpClient.get<SearchResponse>(`/workspaces/${workspaceId}/search`, {
        params: { q: query },
      });
      const { collections, folders, requests } = response.data.data;

      return {
        collections: collections.map((c) => ({
          id: c.id,
          name: c.name,
          description: c.description,
        })),
        folders: folders.map((f) => ({ id: f.id, name: f.name, collectionId: f.collection_id })),
        requests: requests.map((r) => ({
          id: r.id,
          name: r.name,
          method: r.method,
          collectionId: r.collection_id,
          folderId: r.folder_id,
        })),
      };
    } catch (error) {
      throw toAppError(error);
    }
  }
}
